import { ADS_MEDIA_MAX_DURATION_SEC, ADS_MEDIA_MAX_SIDE_PX } from '@wit-support/admin-contracts';
/** Сколько ждать метаданных видео: не вышло — загрузка идёт без них. */
export const VIDEO_META_TIMEOUT_MS = 5_000;
/**
 * Привести прочитанное к контракту `POST /media/uploads` (auto-ads,
 * решения 134–137): ширина и высота — целые 1..16384 и только парой,
 * длительность — > 0 и ≤ 4 ч, с точностью до тысячных. Чего нет или что вне
 * пределов — не отправляется (лучше без фактов, чем 400 на загрузке).
 */
export function sanitizeVideoFacts(raw) {
    const out = {};
    const side = (v) => v !== undefined && Number.isInteger(v) && v >= 1 && v <= ADS_MEDIA_MAX_SIDE_PX;
    if (side(raw.width) && side(raw.height)) {
        out.width = raw.width;
        out.height = raw.height;
    }
    const d = raw.duration;
    if (d !== undefined && Number.isFinite(d) && d > 0) {
        const sec = Math.round(d * 1000) / 1000;
        if (sec > 0 && sec <= ADS_MEDIA_MAX_DURATION_SEC)
            out.durationSec = sec;
    }
    return out;
}
/**
 * Разрешение и длительность видео — из метаданных, без чтения файла целиком:
 * `<video preload="metadata">` по объектному URL (браузер читает только
 * заголовок контейнера). Не вышло (кодек, не браузер, таймаут) — `{}`:
 * загрузка не ждёт и не падает, факты потом пришлёт Meta.
 */
export function readVideoFacts(file, deps = {}) {
    const g = globalThis;
    const createVideo = deps.createVideo ?? (g.document ? () => g.document.createElement('video') : null);
    const createUrl = deps.createObjectUrl ?? g.URL?.createObjectURL?.bind(g.URL) ?? null;
    const revokeUrl = deps.revokeObjectUrl ?? g.URL?.revokeObjectURL?.bind(g.URL) ?? (() => { });
    if (!createVideo || !createUrl)
        return Promise.resolve({});
    return new Promise((resolve) => {
        let url = null;
        let video = null;
        let settled = false;
        const finish = (facts) => {
            if (settled)
                return;
            settled = true;
            clearTimeout(timer);
            if (video) {
                video.onloadedmetadata = null;
                video.onerror = null;
                // отпустить файл: без src элемент не держит ни данных, ни декодера
                video.removeAttribute('src');
                try {
                    video.load();
                }
                catch {
                    /* не важно */
                }
            }
            if (url)
                revokeUrl(url);
            resolve(facts);
        };
        const timer = setTimeout(() => finish({}), deps.timeoutMs ?? VIDEO_META_TIMEOUT_MS);
        try {
            video = createVideo();
            url = createUrl(file);
            video.preload = 'metadata';
            video.muted = true;
            video.onloadedmetadata = () => finish(sanitizeVideoFacts({
                width: video.videoWidth,
                height: video.videoHeight,
                duration: video.duration,
            }));
            video.onerror = () => finish({});
            video.src = url;
        }
        catch {
            finish({});
        }
    });
}
//# sourceMappingURL=media-meta.js.map